import { createContext } from 'react';

export interface NavigationLoaderContextValue {
  isActive: boolean;
  startNavigation: () => void;
  stopNavigation: () => void;
  navigateTo: (url: string) => void;
}

export const NavigationLoaderContext = createContext<NavigationLoaderContextValue | null>(null);
